<template>
  <modal-form
    ref="form"
    :submit="submit"
    :disable-submit="!possuiAlteracao"
    text-close="Fechar"
    v-model="show"
    size="xl"
    @close="close"
  >
    <template v-slot:title>
      Firmas e Poderes
      <v-subheader>
        Proposta #{{ proposta.CodigoPropostaAN }}
      </v-subheader>
    </template>
    <template v-if="!proposta.CodigoVersaoCCB" v-slot:body>
      <v-alert color="warning" text>
        <v-icon color="warning" class="mr-4">ph-warning-circle</v-icon>
        <span class="mt-2">
          Não existe versão de CCB atribuída a esta proposta.
        </span>
      </v-alert>
    </template>
    <template
      v-else-if="proposta.Situacao === $aux.SituacaoPropostaEnum.EmAnalise && !proposta.VencimentoPersonalizado"
      v-slot:body
    >
      <v-alert color="warning" text>
        <v-icon color="warning" class="mr-4">ph-warning-circle</v-icon>
        <span class="mt-2">
          Não é possível alterar os participantes da proposta Em Análise.
        </span>
      </v-alert>
    </template>
    <template v-else v-slot:body>
      <v-row>
        <v-checkbox
          class="ml-4"
          v-model="showPapeis"
          label="Exibir Papéis Selecionados"
        />
        <v-btn
          color="primary"
          small
          class="my-4 ml-auto mr-4"
          @click="incluiAssinante"
        >
          <v-icon small class="mr-2">fas fa-plus</v-icon>
          Incluir Assinantes
        </v-btn>
      </v-row>

      <template v-if="proposta && proposta.Cliente && !loading">
        <PropostaAssinantePapel
          :show-papeis="showPapeis"
          :proposta="proposta"
          :participantes="
            participantes.filter(
              (p) =>
                p.TipoPessoa === $aux.TipoPessoaEnum.PF &&
                p.TipoParticipante === tipoParticipanteCCBEnum.Emitente
            )
          "
          :tipo="tipoParticipanteCCBEnum.Emitente"
          :listDocFederalGarantia="listDocFederalGarantia"
        />
        <PropostaAssinantePapel
          :show-papeis="showPapeis"
          :proposta="proposta"
          :participantes="
            participantes.filter(
              (p) =>
                p.TipoPessoa === $aux.TipoPessoaEnum.PF &&
                p.TipoParticipante === tipoParticipanteCCBEnum.Avalista
            )
          "
          :tipo="tipoParticipanteCCBEnum.Avalista"
          :listDocFederalGarantia="listDocFederalGarantia"
        />

        <template
          v-if="
            participantes.filter(
              (p) => p.TipoParticipante === tipoParticipanteCCBEnum.Outros
            ).length > 0
          "
        >
          <v-card class="mb-4" flat>
            <v-row>
              <v-col cols="6" class="pb-0 primary--text">
                <span
                  class="mb-4 primary--text text-subtitle-1 font-weight-medium"
                  >Outros Assinantes</span
                >
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="6"
                v-for="(item, i) in participantes.filter(
                  (p) => p.TipoParticipante === tipoParticipanteCCBEnum.Outros
                )"
                :key="i"
              >
                <PropostaAssinantePapelItem
                  :show-papeis="showPapeis"
                  :proposta="proposta"
                  :nome="item.Nome"
                  :documento="item.Documento"
                  @hasChanges="(p) => (item.HasChanges = p)"
                  v-model="item.Papeis"
                  :tipo="tipoParticipanteCCBEnum.Outros"
                  :listDocFederalGarantia="listDocFederalGarantia"
                />
              </v-col>
            </v-row>
          </v-card>
        </template>
        <PropostaAssinanteEdit
          ref="incluiAssinante"
          :isCCBEletronica="isCCBEletronica"
          :proposta="proposta"
          :codigoProposta="proposta.Codigo"
          @carregarAssinantes="carregarAssinantes"
          :listDocFederalGarantia="listDocFederalGarantia"
        />
      </template>
    </template>
  </modal-form>
</template>
<script>
export default {
  components: {
    PropostaAssinanteEdit: () => import('./PropostaAssinanteEdit.vue'),
    PropostaAssinantePapel: () => import('./PropostaAssinantePapel.vue'),
    PropostaAssinantePapelItem: () =>
      import('./PropostaAssinantePapelItem.vue'),
  },
  data () {
    return {
      show: false,
      proposta: {},
      action: null,
      participantes: [],
      tipoParticipanteCCBEnum: this.$api.Estruturadas.TipoAssinanteEnum,
      showPapeis: false,
      listBase: [],
      loading: true,
      listDocFederalGarantia: [],
      notificaPorEmail: false,
      notificaPorWhatsApp: false
    };
  },
  computed: {
    possuiAlteracao () {
      const th = this;
      return th.participantes.some((p) => p.HasChanges || p.HasChangesConjuge);
    },
    isCCBEletronica () {
      if (this.$param.EST_PRODUTOS) {
        const tiposCCB = this.$param.EST_PRODUTOS.flatMap((el) =>
          el.Produtos.map((p) => p.E)
        );
        return tiposCCB.includes(this.proposta.CodigoVersaoCCB);
      }
      return false;
    },
  },
  mounted () {
    const th = this
    th.$api.Multiplo.FindRecordProdutoRede().then(function (res) {
      th.notificaPorEmail = th.$aux.NotificaPorEmail.includes(res.ModeloNotificacaoAssinatura)
      th.notificaPorWhatsApp = th.$aux.NotificaPorWhatsApp.includes(res.ModeloNotificacaoAssinatura)
    })
  },
  methods: {
    openModal (sender, action) {
      const th = this;
      th.action = null;
      if (action) {
        th.action = action;
      }
      th.showPapeis = false;
      th.loading = true;
      th.documentoEmitente = sender.ClienteDocumentoFederal;
      if (sender) {
        th.$api.Multiplo.FindRecordProposta({
          guidID: sender.Codigo,
        }).then(function (response) {
          if (th.$api.UI.PostLoadData(response, true)) {
            th.$set(th, 'proposta', response);
            th.show = true;
            th.carregarAssinantes();
            th.carregaGarantias();
          }
        });
      }
    },
    carregarAssinantes () {
      const th = this;
      var dto = {
        parameters: [
          { name: 'CodigoProposta', value: th.proposta.Codigo },
          { name: 'search', value: '' },
        ],
      };
      th.$api.Multiplo.ListCCBDigitalAssinatura(dto).then(function (
        assinantes
      ) {
        if (th.$api.UI.PostLoadData(assinantes, true)) {
          const dto = {
            parameters: [{ name: 'CodigoProposta', value: th.proposta.Codigo }],
          };
          th.$api.Multiplo.CarregarPropostaParticipantes(dto).then(
            function (participantes) {
              if (th.$api.UI.PostLoadData(participantes, true)) {
                if (assinantes.Data.length > 0) {
                  assinantes.Data.forEach((p) => {
                    p.Documento = th.$api.UI.Format.SomenteAlfanumerico(p.Documento);
                    p.Nome = p.Nome.toUpperCase();
                  });
                }
                participantes.forEach((p) => {
                  p.Documento = th.$api.UI.Format.SomenteAlfanumerico(p.Documento);
                  p.Nome = (p.Nome || '').toUpperCase();
                  p.Papeis = [];
                  p.HasChanges = false;

                  if (p.EstadoCivil === th.$aux.EstadoCivilEnum.Casado) {
                    p.DocumentoConjuge = th.$api.UI.Format.SomenteAlfanumerico(
                      p.DocumentoConjuge
                    );
                    p.NomeConjuge = (p.NomeConjuge || '').toUpperCase();
                    p.PapeisConjuge = [];
                    p.HasChangesConjuge = false;
                  } else {
                    p.DocumentoConjuge = null;
                    p.NomeConjuge = null;
                    p.PapeisConjuge = null;
                  }
                });

                th.groupAssinantes(assinantes.Data, participantes);
              }
            }
          );
        }
      });
    },
    carregaGarantias () {
      const th = this;
      const parameters = [
        { name: 'CodigoProposta', value: th.proposta.Codigo },
      ];
      th.$api.Multiplo.ListPropostaGarantiaBem({ parameters }).then((res) => {
        if (th.$api.UI.PostLoadData(res)) {
          th.$set(th, 'listDocFederalGarantia', res.Data.map(({ DocumentoFederalProprietario }) => th.$api.UI.Format.SomenteAlfanumerico(DocumentoFederalProprietario)));
        }
      });
    },
    groupAssinantes (assinantes, participantes) {
      const aux = assinantes.reduce(function (r, a) {
        r[a.Documento] = r[a.Documento] || [];
        r[a.Documento].push(a);
        return r;
      }, Object.create(null));

      Object.keys(aux).forEach((p) => {
        const assinante = aux[p][0];
        const participantesAux = participantes.filter(
          (o) =>
            o.Documento === assinante.Documento ||
            o.DocumentoConjuge === assinante.Documento
        );
        if (participantesAux.length > 0) {
          participantesAux.forEach((participante) => {
            if (
              participante &&
              participante.Documento === assinante.Documento
            ) {
              participante.SenhaAprovacao = assinante.SenhaAprovacao;
              participante.IPAssinatura = assinante.IPAssinatura;
              participante.SenhaTokenEmailSMS = assinante.SenhaTokenEmailSMS;
              participante.DtInclusao = assinante.DtInclusao;
              participante.DtSenhaAprovacao = assinante.DtSenhaAprovacao;
              if (!participante.Opcional || participante.MostrarCCB) {
                participante.Papeis = aux[p].map((l) => {
                  return {
                    text: l.Descricao,
                    codigoAssinatura: l.Codigo,
                  };
                });
              }
            } else if (
              participante &&
              participante.DocumentoConjuge === assinante.Documento
            ) {
              participante.SenhaAprovacaoConjuge = assinante.SenhaAprovacao;
              participante.IPAssinaturaConjuge = assinante.IPAssinatura;
              participante.SenhaTokenEmailSMSConjuge =
                assinante.SenhaTokenEmailSMS;
              participante.DtInclusaoConjuge = assinante.DtInclusao;
              participante.DtSenhaAprovacaoConjuge = assinante.DtSenhaAprovacao;
              if (
                !participante.OpcionalConjuge ||
                participante.MostrarCCBConjuge
              ) {
                participante.PapeisConjuge = aux[p].map((l) => {
                  return {
                    text: l.Descricao,
                    codigoAssinatura: l.Codigo,
                  };
                });
              }
            }
          });
        } else {
          const participante = {
            TipoParticipante: this.tipoParticipanteCCBEnum.Outros,
            Nome: assinante.Nome,
            Email: assinante.Email,
            Documento: assinante.Documento,
            TelefoneCelular: assinante.TelefoneCelular,
            SenhaAprovacao: assinante.SenhaAprovacao,
            IPAssinatura: assinante.IPAssinatura,
            SenhaTokenEmailSMS: assinante.SenhaTokenEmailSMS,
            DtInclusao: assinante.DtInclusao,
            DtSenhaAprovacao: assinante.DtSenhaAprovacao,
            Papeis: aux[p]
              .filter((l) => l.Codigo)
              .map((l) => {
                return {
                  text: l.Descricao,
                  codigoAssinatura: l.Codigo,
                };
              }),
            HasChanges: false,
          };
          participantes.push(participante);
        }
      });

      participantes.forEach((p) => {
        if (p.Papeis) {
          p.Papeis.forEach((papel, i) => {
            const papelAssinatura = this.$aux.PapelAssinatura.find(
              (o) => o.value === papel.text || o.text === papel.text
            );
            if (papelAssinatura) {
              papel = {
                text: papelAssinatura.text,
                value: papelAssinatura.value,
                codigoAssinatura: papel.codigoAssinatura,
              };
            } else {
              papel = {
                text: papel.text,
                value: papel.text,
                codigoAssinatura: papel.codigoAssinatura,
              };
            }
            p.Papeis[i] = papel;
          });
        }

        if (p.PapeisConjuge) {
          p.PapeisConjuge.forEach((papel, i) => {
            const papelAssinatura = this.$aux.PapelAssinatura.find(
              (o) => o.value === papel.text || o.text === papel.text
            );
            if (papelAssinatura) {
              papel = {
                text: papelAssinatura.text,
                value: papelAssinatura.value,
                codigoAssinatura: papel.codigoAssinatura,
              };
            } else {
              papel = {
                text: papel.text,
                value: papel.text,
                codigoAssinatura: papel.codigoAssinatura,
              };
            }
            p.PapeisConjuge[i] = papel;
          });
        }
      });

      this.participantes = participantes.sort(this.sortByConjuge);
      this.listBase = assinantes.map((p) => {
        return { Codigo: p.Codigo, Documento: p.Documento, Papel: p.Descricao };
      });
      this.loading = false;
    },
    submit () {
      const th = this;
      th.$api.Multiplo.FindRecordProposta({
        guidID: th.proposta.Codigo,
      }).then(function (response) {
        if (th.$api.UI.PostLoadData(response)) {
          if (response.Situacao === th.$aux.SituacaoPropostaEnum.EmAnalise && !response.VencimentoPersonalizado) {
            th.$api.UI.ShowError(
              'Erro',
              'Não é possível alterar os participantes da proposta Em Análise.'
            );
          } else {
            let arrayIncluir = [];
            let arrayExcluir = [];

            // controle de exclusão
            const participantePapel = [];
            th.participantes
              .filter(
                (p) =>
                  (p.Papeis && p.Papeis.length > 0) ||
                  (p.PapeisConjuge && p.PapeisConjuge.length > 0)
              )
              .forEach((p) => {
                if (p.Papeis && p.Papeis.length > 0) {
                  p.Papeis.forEach((papel) => {
                    participantePapel.push({
                      Documento: p.Documento,
                      Papel: papel.value,
                    });
                  });
                }

                if (p.PapeisConjuge && p.PapeisConjuge.length > 0) {
                  p.PapeisConjuge.forEach((papel) => {
                    participantePapel.push({
                      Documento: p.Documento,
                      Papel: papel.value,
                    });
                  });
                }
              });

            th.participantes.forEach((sender) => {
              if (sender.HasChanges) {
                arrayIncluir.push(
                  ...sender.Papeis.filter(
                    (p) =>
                      !th.listBase.some(
                        (o) =>
                          o.Documento === sender.Documento &&
                          o.Papel === p.value
                      )
                  ).map((p, i) => {
                    return {
                      Nome: sender.Nome,
                      Email: sender.Email,
                      Documento: sender.Documento,
                      TelefoneCelular: sender.TelefoneCelular,
                      Papel: p.value,
                    };
                  })
                );
                arrayExcluir.push(
                  ...th.listBase.filter(
                    (p) =>
                      p.Documento === sender.Documento &&
                      !sender.Papeis.some((o) => p.Papel === o.value)
                  )
                );
              }
              if (sender.HasChangesConjuge) {
                arrayIncluir.push(
                  ...sender.PapeisConjuge.filter(
                    (p) =>
                      !th.listBase.some(
                        (o) =>
                          o.Documento === sender.DocumentoConjuge &&
                          o.Papel === p.value
                      )
                  ).map((p, i) => {
                    return {
                      Nome: sender.NomeConjuge,
                      Email: sender.EmailConjuge,
                      Documento: sender.DocumentoConjuge,
                      TelefoneCelular: sender.TelefoneCelularConjuge,
                      Papel: p.value,
                    };
                  })
                );
                arrayExcluir.push(
                  ...th.listBase.filter(
                    (p) =>
                      p.Documento === sender.DocumentoConjuge &&
                      !sender.PapeisConjuge.some((o) => p.Papel === o.value)
                  )
                );
              }
            });

            var insertDone;
            var removeDone = false;
            var updateDone = false;

            // Mesmo CPF em +1 Participante: pode excluir o item em um e manter no outro, ignorar exclusão nesses casos
            arrayExcluir = arrayExcluir.filter(
              (p) =>
                !participantePapel.some(
                  (o) => p.Documento === o.Documento && p.Papel === o.Papel
                )
            );

            // retirar referências de mesmo ponteiro nos itens do array
            arrayIncluir = arrayIncluir.map((p) => {
              return { ...p };
            });
            arrayExcluir = arrayExcluir.map((p) => {
              return { ...p };
            });

            // controle de duplicados
            arrayExcluir.forEach((p, i) => {
              p.Indice = i;
            });
            arrayIncluir.forEach((p, i) => {
              p.Indice = i;
            });

            // Retirar duplicados
            arrayIncluir = arrayIncluir.filter(
              (p) =>
                !arrayIncluir.some(
                  (o) =>
                    o.Indice < p.Indice &&
                    p.Documento === o.Documento &&
                    p.Papel === o.Papel
                )
            );
            arrayExcluir = arrayExcluir.filter(
              (p) =>
                !arrayExcluir.some(
                  (o) =>
                    o.Indice < p.Indice &&
                    p.Documento === o.Documento &&
                    p.Papel === o.Papel
                )
            );

            th.salvarAssinante(
              // Mesmo CPF em +1 Participante: pode excluir o item em um e incluir no outro, ignorar nesses casos
              arrayIncluir,
              arrayExcluir,
              function (p) {
                // controle de métodos finalizados
                if (p === 'i') {
                  insertDone = true;
                } else if (p === 'r') {
                  removeDone = true;
                } else if (p === 'u') {
                  updateDone = true;
                }

                if (insertDone && removeDone && updateDone) {
                  th.$api.UI.Mensagem(
                    'info',
                    'Assinantes atualizados!',
                    function () {
                      th.close(
                        th.proposta.Situacao ===
                          th.$aux.SituacaoPropostaEnum.EmDigitacao
                          ? 'openAction'
                          : null
                      );
                    }
                  );
                }
              }
            );
          }
        }
      });
    },
    salvarAssinante (arrayIncluir, arrayExcluir, callback) {
      const th = this;
      if (arrayIncluir.length > 0) {
        arrayIncluir = arrayIncluir.map((sender) => {
          var dto = {
            CodigoProposta: th.proposta.Codigo,
            Nome: sender.Nome,
            Email: sender.Email,
            Documento: sender.Documento,
            TelefoneCelular: sender.TelefoneCelular,
            NotificarPorEmail: th.isCCBEletronica && th.notificaPorEmail,
            NotificarPorWhatsApp: th.isCCBEletronica && th.notificaPorWhatsApp,
            Descricao: sender.Papel.toString().substring(0, 100),
          };
          return dto;
        });
      }
      if (arrayExcluir.length > 0) {
        arrayExcluir = arrayExcluir.map((p) => p.Codigo);
      }

      th.$api.Multiplo.InsertCCBDigitalAssinaturas({
        dto: arrayIncluir,
      }).then(function (response) {
        if (th.$api.UI.PostLoadData(response, true)) {
          callback('i');
        }
      });
      th.$api.Multiplo.RemoveCCBDigitalAssinaturas({
        dto: arrayExcluir,
      }).then(function (response) {
        if (th.$api.UI.PostLoadData(response, true)) {
          callback('r');
        }
      });

      var participantes = th.participantes
        .filter((p) => p.TipoParticipante !== th.tipoParticipanteCCBEnum.Outros)
        .map((p) => {
          return {
            Codigo: p.Codigo,
            TipoPessoa: p.TipoPessoa,
            TipoParticipante: p.TipoParticipante,
            MostrarCCB: p.MostrarCCB,
            MostrarCCBConjuge: p.MostrarCCBConjuge,
          };
        });
      th.$api.Multiplo.UpdatePropostaParticipantes({
        dto: participantes,
      }).then(function (response) {
        if (th.$api.UI.PostLoadData(response, true)) {
          callback('u');
        }
      });
    },
    close (param) {
      const th = this;
      th.show = false;
      if (th.possuiAlteracao || th.action) {
        th.$emit('close', th.proposta.Codigo, th.action ? th.action : param);
      }
    },
    incluiAssinante () {
      this.$refs.incluiAssinante.openModal();
    },
    sortByConjuge (item) {
      if (item.NomeConjuge || item.NomeConjuge === '') {
        return -1;
      } else {
        return 1;
      }
    }
  },
};
</script>
